import {Link}from 'react-router-dom';
import "../Maintenance/Maintenance.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
import image1 from '../../image/organisation.jpg'

import centralair from '../../image/centralair.jpg'
import regulation from '../../image/regulation.jpg'
import chauffage from '../../image/chauffage.jpg'
import bms from '../../image/bms.jpg'
import eauchaud from '../../image/eauchaud.jpg'
import proto from '../../image/proto.jpg'
import metrologie from '../../image/metrologie.jpg'
import picine from '../../image/picine.jpg'
import pompe from '../../image/pompe.jpg'
import capitor from '../../image/capitor.jpg'
import traitmentAir from '../../image/traitmentAir.jpg'
import elecGener from '../../image/elecGener.jpg'

import AOS from 'aos';
import Model from '../../component/ModelButton/Model';




function Maintenance (){
    AOS.init();
    return(
     <div id="#">
        
         <div className=" container-fluid bg-secondary pt-2 pt-lg-5 pb-2 mb-5">
            <div className="container py-5">
                <div className="row row-box align-items-center py-4">
                    <div className="col-md-6 text-center text-md-left">
                        <h1 className="mb-4 mb-md-0 text-white">Maintenance</h1>
                     </div>
                        <div className="col-md-6 text-center text-md-right">
                            <div className="d-inline-flex align-items-center">
                                <Link className="btn text-white" to="/">Home</Link>
                                <FontAwesomeIcon className="fas fa-angle-right text-white" icon={faAngleRight} />
                              
                                <Link className="btn text-white disabled" to="/maintenance">Maintenance</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        <div id="c" className="maintenance">

        <div className="container">
            <div className="row">
             <div className=" col-md-3">
                <img  data-aos="fade-right" className="img1" src={image1} alt=""  />
             </div>
             <div className="col-md-9">
              <p style={{marginTop:"75px"}} className="p-ses" data-aos="fade-left" >With a responsive organization, MPEMI offers multitechnical and multiservice maintenance services adapted to the current and future needs and challenges of its customers. In the industrial, tertiary, hospitality and residential markets, MPEMI assists its clients in the management and operation of their real estate assets and their production tools.<br></br>
               </p>
             </div>
            </div>
         </div>
         <div className="container" >
             
           
            <div className="container service" id="Domaines-d’intervention" >
             <div className="row">
                 <div className="col-md-12 Pandingh2">
                    <h2 className="h2-ses" style={{textAlign:"center"}} >
                    Areas of intervention
                    </h2>
                 </div>
                 <div className="row" id="#Domaines-d’intervention">
                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="100" >
                    <div className="service-item">
                    <div className="service-img">
                    <img src={regulation} alt="QSl" />
                    <div className="service-overlay">
                    <p>
                    Industrial automation control systems involve the integration of devices, machines, and equipment within the manufacturing plant & building.
                    </p>
                    </div>
                    </div>
                    <div className="service-text">
                    <h3>Automation & Control</h3>
                    <Model
                    title ="Automation & Control"
                    body="Industrial automation control systems involve the integration of devices, machines, and equipment within the manufacturing plant & building."
                    />
                    </div>
                   
                    </div>
                    </div>
                    
                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="200">
                    <div className="service-item">
                    <div className="service-img">
                    <img src={elecGener} alt="qsd"/>
                    <div className="service-overlay">
                    <p>
                    Assembly, installation and maintenance of electrical box. <br/><br/> Sizing and installation of capacitor banks .                   </p>
                    </div>
                    </div>
                    <div className="service-text">
                    <h3>Electricity</h3>
                    <Model
                    title ="Electricity"
                    body={["Assembly, installation and maintenance of electrical box. ",<br/>,<br/>, "Sizing and installation of capacitor banks .                   "]}
                    />
                    </div>
                    </div>
                    </div>
                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="300" >
                    <div className="service-item">
                    <div className="service-img">
                    <img src={metrologie} alt="no" />
                    <div className="service-overlay">
                    <p>
                    Assistance in tools choosing, calibration, validation methods,uncertainty estimation & instrument management  . 
                                     </p>
                    </div>
                    </div>
                    <div className="service-text">
                    <h3>Metrology</h3>
                    <Model
                    title ="Metrology"
                    body=" Assistance in tools choosing, calibration, validation methods,uncertainty estimation & instrument management  ."
                    />
                    </div>
                    </div>
                    </div>
                   
                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="100" >
                    <div className="service-item">
                    <div className="service-img">
                    <img src={pompe} alt="rf" />
                    <div className="service-overlay">
                    <p>
                      <ul>
                          <li>
                          Construction and maintenance of water distribution networks.

                          </li>
                          <li>
                          Construction and maintenance of sanitation networks.

                          </li>
                          <li>
                          Installations of telemanagement systems.

                          </li>
                          <li>
                          Detection and repair of leaks.

                          </li>
                      </ul>
                    </p>
                    </div>
                    </div>
                    <div className="service-text">
                    <h3> Sanitation	</h3>
                    <Model
                    title ="Sanitation"
                    body={[" Construction and maintenance of water distribution networks.",<br/>,"Construction and maintenance of sanitation networks.",<br />," Installations of telemanagement systems.",<br />," Detection and repair of leaks."]}
                    />             
                     </div>
                    </div>
                    </div>
                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="200" >
                    <div className="service-item">
                    <div className="service-img">
                    <img src={chauffage} alt="dsq" />
                    <div className="service-overlay">
                    <p>
                    Heating, Ventilating and Air Conditioning  : 
                        
                            Installation &
                            
                            Maintenace
                                         
                         </p>
                    </div>
                    </div>
                    <div className="service-text">
                    <h3>HVAC </h3>
                    <Model
                    title ="HVAC"
                    body="Heating, Ventilating and Air Conditioning  :  Installation &Maintenace"
                    />                    </div>
                    </div>
                    </div>
                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="300" >
                    <div className="service-item">
                    <div className="service-img">
                    <img src={traitmentAir} alt="dsq" />
                    <div className="service-overlay">
                    <p>
                    The primary goal of infrared thermography is to confirm machinery is running normally and to detect abnormal heat patterns within a machine, indicating inefficiency and defects.                    </p>
                    </div>
                    </div>
                    <div className="service-text">
                    <h3>Infrared thermography</h3>
                    <Model
                    title ="Infrared thermography"
                    body="The primary goal of infrared thermography is to confirm machinery is running normally and to detect abnormal heat patterns within a machine, indicating inefficiency and defects."
                    />
                    </div>
                    </div>
                    </div>
                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="100" >
                    <div className="service-item">
                    <div className="service-img">
                    <img src={bms} alt="dsq" />
                    <div className="service-overlay" >
                    <p >
                    <br/>
                      <b style={{color:"red"}}> BMS/GTB/GTC</b>
                     <ul >
                         <li >
                             
                         Supervision et monitoring                         </li>
                         <li >
                         Smart and sustainable building
                         </li>
                         <li >
                         measurement and control technology for climate, air quality and energy management

                         </li>
                         <li >
                         climate control, fire detection, access control, CCTV and many other systems.

                         </li>
                     </ul >
                    </p>
                    </div>
                    </div>
                    <div className="service-text" id="#BMS">
                    <h3>Building Management System </h3>
                    <Model
                    title ="Building Management System"
                    body={["Supervision et monitoring ", <br/>," Smart and sustainable building",<br/>,"measurement and control technology for climate, air quality and energy management",<br />,"climate control, fire detection, access control, CCTV and many other systems."]}
                    />            
                      </div>
                    </div>
                    </div>
                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="200" >
                    <div className="service-item">
                    <div className="service-img">
                    <img src={picine} alt="dsq" />
                    <div className="service-overlay">
                    <p>
                      <ul>
                          <li>
                          Leak detection
                          </li>
                          <li>
                          Verification of deterioration

                          </li>
                          <li>
                          Inspection of metallic elements

                          </li>
                          <li>
                          Control of the hardness or flow of a pipe.

                          </li>
                      </ul>
                    </p>
                    </div>
                    </div>
                    <div className="service-text">
                    <h3>Ultrasonic testing </h3>
                    <Model
                    title ="Ultrasonic testing"
                    body={[" Leak detection",<br/>," Verification of deterioration",<br />," Inspection of metallic elements",<br />,"Control of the hardness or flow of a pipe."]}
                    />                 </div>
                    </div>
                    </div>
                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="300" >
                    <div className="service-item">
                    <div className="service-img">
                    <img src={centralair} alt="dsq" />
                    <div className="service-overlay">
                    <p>
                      <ul>
                          <li>
                          Turnkey installations. Including electrical work, duct work and air & water piping.

                          </li>
                          <li>
                          Preventive Maintenance for Air Compressors, Vacuum Pumps and related components.

                          </li>
                          <li>
                          Energy optimization

                          </li>
                      </ul>
                    </p>
                    </div>
                    </div>
                    <div className="service-text">
                    <h3>Compressed air</h3>
                    <Model
                    title ="Compressed air"
                    body={["Turnkey installations. Including electrical work, duct work and air & water piping.",<br/>,"Preventive Maintenance for Air Compressors, Vacuum Pumps and related components.",<br />,"Energy optimization"]}
                    />
                    </div>
                    </div>
                    </div>
                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="100" >
                    <div className="service-item">
                    <div className="service-img">
                    <img src={eauchaud} alt="dsq" />
                    <div className="service-overlay">
                    <p>
                     <ul>
                         <li>
                         Lean manufacturing 
                         </li>
                         <li>
                         Blockchain

                         </li>
                         <li>
                         Industrial IoT

                         </li>
                         <li >
                         Computerized maintenance management system CMMS/GMAO
                         </li>
                     </ul>
                    </p>
                    </div>
                    </div>
                    <div className="service-text">
                    <h3>Maintenance 4.0</h3>
                    <Model
                    title ="Maintenance 4.0"
                    body={["Lean manufacturing ",<br/>," Blockchain",<br />,"Industrial IoT",<br />,"Computerized maintenance management system CMMS/GMAO"]}
                    />                   </div>
                    </div>
                    </div>
                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="200" >
                    <div className="service-item">
                    <div className="service-img">
                    <img src={capitor} alt="dsq" />
                    <div className="service-overlay">
                    <p>sizing, installation and maintenance of capacitor banks for reactive energy compensation and Power Factor Correction.Harmonic filtring .
                    </p>
                    </div>
                    </div>
                    <div className="service-text">
                    <h3>Capacitor banks </h3>
                    <Model
                    title ="Capacitor banks "
                    body="Sizing, installation and maintenance of capacitor banks for reactive energy compensation and Power Factor Correction.
                    Harmonic filtring"
                    />                  
                      </div>
                    </div>
                    </div>
                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="300" >
                    <div className="service-item">
                    <div className="service-img">
                    <img src={proto} alt="dsq" />
                    <div className="service-overlay">
                    <p>
                    Starting with our Advanced CAD Services or Mechanical Design Services, we can create and test fully-functional prototypes, including electronic, automatic and mechatronic systems. In addition to functionality verification and testing
                    </p>
                    </div>
                    </div>
                    <div className="service-text">
                    <h3>Prototype development</h3>
                    <Model
                    title ="Prototype development"
                    body="Starting with our Advanced CAD Services or Mechanical Design Services, we can create and test fully-functional prototypes, including electronic, automatic and mechatronic systems. In addition to functionality verification and testing"
                    />                
                    </div>
                    </div>
                    </div>
                    </div>
             </div>
            </div>
            <div id="Gammes-des-services-et-des-solutions">
                <div className="container">

                <div className="row">
                <div className="col-md-12 Pandingh2">
                    <h2 className="h2-ses" style={{textAlign:"center"}} >
                    Range of services and solutions
                    </h2>
                    <p className="p-ses" >
                    MPEMI brings together the skills necessary for the management and maintenance of projects of any size. MPEMI benefits from the tools and methods to give installations all the reliability, traceability and durability required. A personalized maintenance offer: MPEMI undertakes through performance contracts to advise its customers on energy management and equipment performance, to guarantee service levels and to support them in controlling their consumption, reducing energy and carbon consumption, life management and equipment performance.
                    </p>
                 </div>
                </div>
               
                </div>
            </div>
         </div>
        </div>
     </div>
    );
}
export default Maintenance;





 